import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/traversal/add/add.js";
import "dabbyjs/src/traversal/next-prev/next-prev.js";
import "dabbyjs/src/traversal/children/children.js";

function updateSelection(obj, selection, current = null, checked = null) {
	obj.each(function () {
		const $this = $(this),
			val = $this.attr("value");

		// optionally write the change into selection
		if (checked !== null) {
			if (!selection.hasOwnProperty(val)) {
				selection[val] = {tags: []};
				// seed metadata from the inputs in this entry's label
				$("input[data-selection-key]", $this.next()).each(function () {
					selection[val][this.dataset.selectionKey] = Math.max(0, parseInt(this.value, 10) || 0);
				});
			}
			if (current !== null) {
				const index = selection[val].tags.indexOf(current);
				if (index === -1 && checked) {
					selection[val].tags.push(current);
				} else if (index > -1 && !checked) {
					selection[val].tags.splice(index, 1);
				}
			} else if (!checked) {
				delete selection[val];
			}
		}

		// derive checkbox visual state from selection
		$this.prop("checked", !selection.hasOwnProperty(val) ? false : (current === null ? selection[val].tags.length === 0 : selection[val].tags.includes(current)));
	});
}

function updateTags(tags, selection, obj, cls) {
	obj.each(function () {
		const item = $(this),
			val = item.attr("value"),
			label = item.next(),
			containercls = cls + "__label-tags";

		// ensure container exists
		let container = $("." + containercls, label);
		if (container.length === 0) {
			container = $("<div>", {"class": containercls}).appendTo(label);
		}

		// map the items
		const items = {};
		container.children().each(function () {
			const $this = $(this),
				id = $this.data("tag-id");
			if (id) {
				items[id] = $(this);
			}
		});

		// apply tags
		(selection[val]?.tags || []).forEach(value => {
			if (value) {
				if (!items.hasOwnProperty(value)) {
					container.append($("<div>", {"class": containercls + "-item", "data-tag-id": value, text: tags[value].name}));
				}
				delete items[value];
			}
		});

		// remove left over tags
		for (const id in items) {
			items[id].remove();
		}
	});
}

export default obj => {
	obj.each(function () {
		const $this = $(this),
			cls = $this.attr("class").split(" ").reverse()[0],
			div = $("<div>", {"class": cls + "__tags"}),
			controls = $("input:not([data-selection-key])", $this),
			input = $("#" + $this.data("for")),
			selection = JSON.parse(input.val() || "{}"),
			tags = $this.data("tags");

		// render tag controls
		let buttons = $(),
			current = null,
			lastClicked = null,
			shiftHeld = false;
		for (let [id, values] of Object.entries(tags)) {
			const button = $("<div>", {text: values.name, title: values.desc, "class": cls + "__tags-item", click: button => {
				const val = current !== id ? id : null

				// set the controls to have the correct selection for the current tag
				updateSelection(controls, selection, val);

				// update the tag button active state
				buttons.each(function () {
					const item = $(this);
					item.toggleClass(cls + "__tags-item--active", this === button.target && current !== id);
				});
				current = val;
			}});
			div.append(button);
			buttons = buttons.add(button);
		};
		$this.append(div);

		// track shift state so the change handler can detect shift+click without binding the click event
		$(document).on("keydown keyup", function (event) {
			shiftHeld = event.shiftKey;
		});
		$this.on("mousedown", function (event) {
			// suppress shift+mousedown's default of extending the text selection, otherwise it can disrupt the click and prevents the checkbox toggling
			if (event.shiftKey && !event.target.closest("[data-selection-key]")) {
				event.preventDefault();
			}
			shiftHeld = event.shiftKey;
		});
		// Browsers suppress label-activation on shift+click — the click reaches the label but the linked input is never toggled, so no change event fires. Detect that case and dispatch the change manually so the change handler (which does the actual work) still runs.
		$this.on("click", function (event) {
			if (event.shiftKey && !event.target.closest("[data-selection-key]")) {
				const label = event.target.closest("label");
				if (label && label.control) {
					event.preventDefault();
					label.control.checked = !label.control.checked;
					label.control.dispatchEvent(new Event("change", {bubbles: true}));
				}
			}
		});

		// sync per-entry metadata inputs into the selection JSON
		$("input[data-selection-key]", $this).on("change", function () {
			const label = this.closest("label"),
				url = label?.control?.value,
				key = this.dataset.selectionKey;
			if (url && selection.hasOwnProperty(url)) {
				selection[url][key] = Math.max(0, parseInt(this.value, 10) || 0);
				input.val(JSON.stringify(selection));
			}
		});

		// bind controls
		controls.on("change", function () {
			const item = $(this),
				checked = item.prop("checked");
			let toUpdate = item,
				rangeExpanded = false;

			// extend the change across the range when shift+click
			if (shiftHeld && lastClicked && lastClicked !== this) {
				const all = [];
				controls.each(function () {
					all.push(this);
				});
				const a = all.indexOf(lastClicked),
					b = all.indexOf(this);
				if (a !== -1 && b !== -1) {
					const [from, to] = a < b ? [a, b] : [b, a];
					toUpdate = $(all.slice(from, to + 1));
					rangeExpanded = true;
				}
			}

			// set anchor unless we just used it to expand a range
			if (!rangeExpanded) {
				lastClicked = this;
			}
			shiftHeld = false;

			// set selection
			updateSelection(toUpdate, selection, current, checked);

			// update the interface
			updateTags(tags, selection, controls, cls);

			// write the selection to the form
			input.val(JSON.stringify(selection));
		});

		// set selection
		updateSelection(controls, selection);

		// restore metadata-input values from any prior selection (e.g. after validation re-render)
		$("input[data-selection-key]", $this).each(function () {
			const label = this.closest("label"),
				url = label?.control?.value,
				key = this.dataset.selectionKey;
			if (url && selection[url] && selection[url][key] !== undefined) {
				this.value = selection[url][key];
			}
		});

		// set initial
		updateTags(tags, selection, controls, cls);
	});
};